import React from 'react';

import PlaceholderTab from '~/components/Offers/Detail/OfferBuilder/shared/PlaceholderTab';

import { INCLUSION_FIELDS } from './fields';

export default function InclusionsTab() {
  return <PlaceholderTab configuredFieldCount={INCLUSION_FIELDS.length} title="Inclusions" />;
}
